// extracted by mini-css-extract-plugin
export var container = "CouponNotice_container__Xoa+v";